"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/Setup/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');

var _ui = require('web/services/ui');
var _MobileSetup = require('./MobileSetup'); var _MobileSetup2 = _interopRequireDefault(_MobileSetup);
var _DesktopSetup = require('./DesktopSetup'); var _DesktopSetup2 = _interopRequireDefault(_DesktopSetup);

// VideoRoomSession.publishProblem (throttled); the setup containers pass it
// StreamManager failures.


















const Setup = ({
  onCycleCam,
  isCamCycleAvailable,
  gotoPreCall,
  goBack,
  areCamIssuesPresent,
  onUserProblemPublish,
}) => {
  const [isMobileActive, setIsMobileActive] = _react.useState.call(void 0, _ui.isMobileScreen)

  // One throttled handler per instance, like the class field, so the listener
  // removed on unmount is the one added on mount.
  const [watchResize] = _react.useState.call(void 0, () => _lodash.throttle.call(void 0, 
    () => setIsMobileActive(_ui.isMobileScreen.call(void 0, )),
    100,
  ))

  // componentDidMount / componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => {
    window.addEventListener('resize', watchResize)
    return () => window.removeEventListener('resize', watchResize)
  }, [watchResize])

  return (
    _react2.default.createElement('div', { className: "meeting--setup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
      ,  isMobileActive
        ? (
          _react2.default.createElement(_MobileSetup2.default, {
            onCycleCam: onCycleCam,
            goBack: goBack,
            gotoPreCall: gotoPreCall,
            isCamCycleAvailable: isCamCycleAvailable,
            areCamIssuesPresent: areCamIssuesPresent,
            onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
          )
          ) : (
          _react2.default.createElement(_DesktopSetup2.default, {
            gotoPreCall: gotoPreCall,
            onUserProblemPublish: onUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          )
          )
      
    )
  )
}

exports. default = Setup
